export default {
    setQuantity: (state, quantity) => state.quantity = quantity,
}
